import _ from 'lodash';
import {
  getRequest,
  patchRequest,
  postRequest
} from '../../Common/network-call';

// constants
import { SCRIPT_URI_ADDON, TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

// actions
import { clearExhibitorDetails } from '../../exhibitors/actions';
import { clearSponsorDetails } from '../../sponsors/actions';
import { maintainResponseStructure } from '../../../util/util-common';

export const MY_SCAN_LIST = 'MY_SCAN_LIST';
export const SELECTED_SCAN_ITEM = 'SELECTED_SCAN_ITEM';
export const SELECTED_SCAN_LINKED_ITEM = 'SELECTED_SCAN_LINKED_ITEM';
export const SCANNED_IDS = 'SCANNED_IDS';
export const SCANNED_USERS = 'SCANNED_USERS';
export const LEADFORM = 'LEADFORM';

export const fetchAppUserScanList = (session, exhibitorid = null, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND${
      exhibitorid
        ? `((userid=${session.userid})OR(exhibitorid=${exhibitorid}))`
        : `(userid=${session.userid})`
    }`
  );
  let fetchRelated = exhibitorid
    ? 'appuser_by_scanneduserid,exhibitors_by_exhibitorid'
    : 'appuser_by_scanneduserid';
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.userScans}?include_count=true&related=${fetchRelated}&filter=(${filter})`;

  return dispatch => {
    // dispatch({ type: MY_SCAN_LIST, payload: {} });
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        let userArr = [],
          vCardArr = [];

        _.map(res.resource, item => {
          if (item.type == 'exhibitor') vCardArr.push(item);
          else userArr.push(item);
        });

        let dataObj = {
          users: userArr,
          vcard: vCardArr
        };

        let payloadBody = {
          count: res.meta.count,
          data: dataObj
        };
        dispatch({ type: MY_SCAN_LIST, payload: payloadBody });
        callback({ success: 1, data: payloadBody });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const exportScanListToMail = (session, callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.userQR.exportScan.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.userQR.exportScan.payload);
  postBody.eventid = session.eventid;
  postBody.userid = session.userid;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, response: res });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const selectScanItem = props => {
  if (_.isEmpty(props)) {
    return dispatch => dispatch({ type: SELECTED_SCAN_ITEM, payload: {} });
  } else {
    const { session = null, value } = props;

    if (_.isEmpty(value)) {
      return dispatch => {
        dispatch(clearSelectedScanItem());
        dispatch({ type: SELECTED_SCAN_ITEM, payload: value });
      };
    } else
      return dispatch => {
        dispatch(clearSelectedScanItem());
        dispatch(clearExhibitorDetails());
        dispatch(clearSponsorDetails());
        dispatch({ type: SELECTED_SCAN_ITEM, payload: value });
      };
  }
};

export const clearSelectedScanItem = () => {
  return dispatch => dispatch({ type: SELECTED_SCAN_ITEM, payload: {} });
};

export const updateScanUserNote = (
  session,
  value,
  exhibitorid = null,
  callback
) => {
  let updateItemId = value.id;
  let patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.userScans}/${updateItemId}`;
  let patchBody = _.omit(value, ['id']);

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      response => {
        dispatch(
          fetchAppUserScanList(session, exhibitorid, res => {
            if (res.success) {
              let users = res.data.data.users;
              let vcard = res.data.data.vcard;

              let userFilterArr = _.filter(
                  users,
                  item => item.id == updateItemId
                ),
                vcardFilterArr = [];
              if (userFilterArr.length > 0) {
                dispatch(selectScanItem({ session, value: userFilterArr[0] }));
                callback({
                  success: 3,
                  patch: true,
                  fetch: true,
                  select: true
                });
              } else {
                vcardFilterArr = _.filter(
                  vcard,
                  item => item.id == updateItemId
                );
                if (vcardFilterArr.length > 0) {
                  dispatch(
                    selectScanItem({ session, value: vcardFilterArr[0] })
                  );
                  callback({
                    success: 3,
                    patch: true,
                    fetch: true,
                    select: true
                  });
                } else {
                  callback({
                    success: 2,
                    patch: true,
                    fetch: true,
                    select: false
                  });
                }
              }
            } else callback({ success: 1, patch: true, fetch: false });
          })
        );
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const setSelectedScanLinkedItem = value => {
  return dispatch => {
    dispatch(clearSelectedScanLinkedItem());
    dispatch({ type: SELECTED_SCAN_LINKED_ITEM, payload: value });
  };
};

export const clearSelectedScanLinkedItem = () => {
  return dispatch => {
    dispatch({ type: SELECTED_SCAN_LINKED_ITEM, payload: {} });
  };
};

export const fetchExportScanCSVData = (session, callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.userQR.exportMyData.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.userQR.exportMyData.payload);
  postBody.eventid = session.eventid;
  postBody.userid = session.userid;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource, message: null });
      },
      error => {
        callback({ success: 0, data: null, message: error });
      }
    );
  };
};

export const getUsersList = (session, ids) => {
  const combine = list => {
    let inStr = '( ';
    _.map(list, (item, index) => {
      if (index == list.length - 1) {
        inStr += item + ' )';
      } else {
        inStr += item + ', ';
      }
    });
    return inStr;
  };

  if (ids.length > 0) {
    const userIDs = combine(ids);
    let fetchFilter = encodeURI(
      `((eventid=${session.eventid})AND(appuserid IN ${userIDs}))`
    );
    let getUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?include_count=true&related=sponsor_by_sponsoridfk,exhibitors_by_exhibitoridfk&filter=${fetchFilter}`;
    return dispatch => {
      getRequest(
        getUrl,
        session,
        dispatch,
        res => {
          dispatch({ type: SCANNED_USERS, payload: res?.resource });
        },
        error => {}
      );
    };
  }

  return dispatch => {};
};

export const fetchMyScans = session => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.myScans.endpoint}`;

  return dispatch => {
    postRequest(
      url,
      null,
      session,
      dispatch,
      res => {
        const ids = _.map(res?.resource.exhibitors, ea => ea);
        _.map(res?.resource.scans, ea => ids.push(ea.scanneduserid));
        dispatch({ type: SCANNED_IDS, payload: res.resource });
        dispatch(getUsersList(session, ids));
      },
      error => {}
    );
  };
};

export const fetchLeadform = (session, id) => {
  if (id) {
    const getUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.eventForms}/${id}?&filter=eventid=${session.eventid}&fields=${FIELDS.eventForms.minInfo}`;
    return dispatch => {
      getRequest(
        getUrl,
        session,
        dispatch,
        res => {
          dispatch({ type: LEADFORM, payload: JSON.parse(res?.formjson) });
        },
        error => {}
      );
    };
  }

  return dispatch => {};
};

export const updateLeadForm = (session, isExternal, formJson, id, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${
    isExternal ? TABLES.externalLeads : TABLES.userScans
  }/${id}`;
  let patchBody = {
    eventid: session.eventid,
    response_lead: JSON.stringify(maintainResponseStructure(formJson))
  };

  return dispatch => {
    patchRequest(
      url,
      patchBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const getUserQR = (session, callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventQr.myQR.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.eventQr.myQR.payload);
  postBody.userid = session.userid;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res.resource });
      },
      error => {
        callback({ success: 0, data: {} });
      }
    );
  };
};
